export default __webpack_public_path__ + "static/media/shopyfy.ffc1ae39.png";